import { API_HOST } from "../configs/api.js";
import { deleteRequest, getRequest, postRequest } from "./request.js";
import { hideLoader, showLoader } from "./utils.js";

const updateDocsList = async (
  editor,
  pathName,
  docComponent,
  setMsg,
  setError,
  presentation
) => {
  try {
    const response = await getRequest(`assets/${pathName}/list-docs`);

    const docListHolder = document.querySelector("#doc-list-group");

    if (response.data.isSuccess) {
      let list = "";
      const sharedDocs = response.data.docs.shared;
      const keyMessageDocs = response.data.docs.keyMessage;

      sharedDocs.forEach((docInfo) => {
        const { docName, docSrc } = docInfo;
        list += `<li class="doc-list-item list-group-item d-flex justify-content-between" docName="${docName}" style="cursor: pointer" data-doc-href="${docSrc}">
              <span class="text-break">${docName}</span>
              <span class="badge bg-primary" title="This document is a shared asset">Shared</span>
          </li>`;
      });

      keyMessageDocs.forEach((docInfo) => {
        const { docName, docSrc } = docInfo;
        let src = docSrc.replace(`${API_HOST}assets/${pathName}/`, "");
        if (pathName.startsWith("imports")) {
          if (src.startsWith(`${presentation.structure.docs[0]}`)) {
            list += `<li class="doc-list-item list-group-item d-flex justify-content-between" docName="${docName}" style="cursor: pointer" data-doc-href="${docSrc}">
              <span class="text-break">${docName}</span>
              <span class="delete-doc btn btn-outline-danger btn-sm" role="button" style="border-radius: 5px !important;">X</span>
          </li>`;
          } else {
            list += `<li class="doc-list-item list-group-item d-flex justify-content-between" docName="${docName}" style="cursor: pointer" data-doc-href="${docSrc}">
            <span class="text-break">${docName}</span>
            <span class="badge bg-primary" title="This document is a non deletable asset">Non deletable</span>
        </li>`;
          }
        } else {
          list += `<li class="doc-list-item list-group-item d-flex justify-content-between" docName="${docName}" style="cursor: pointer" data-doc-href="${docSrc}">
          <span class="text-break">${docName}</span>
          <span class="delete-doc btn btn-outline-danger btn-sm" role="button" style="border-radius: 5px !important;">X</span>
      </li>`;
        }
      });

      docListHolder.innerHTML = list;
    } else {
      docListHolder.innerHTML = `<li class="list-group-item d-flex text-danger">
          No documents available !!
      </li>`;
    }
  } catch (error) {
    setError(true);
    setMsg(error);
  }

  const deleteDocButtons = document.querySelectorAll("span.delete-doc");
  deleteDocButtons.forEach((deleteButton) => {
    deleteButton.addEventListener("click", async (e) => {
      e.stopImmediatePropagation();
      try {
        const docName =
          e.target.parentNode.getElementsByTagName("span")[0].innerHTML;
        const userConfirmation = window.confirm(
          `Are you sure you want to delete ${docName}`
        );

        if (userConfirmation) {
          const response = await deleteRequest(
            `assets/${pathName}/docs/${docName}`
          );
          if (response.data.isSuccess) {
            e.target.parentNode.remove();
          } else {
            if (response.data.message) {
              setError(true);
              setMsg(response.data.message);
            }
          }
        }

        const docHref =
          deleteButton.parentElement.getAttribute("data-doc-href");
        const docComponents = editor.getWrapper().findType("Doc-Link");
        for (const doc of docComponents) {
          if (doc.getAttributes().href === docHref) {
            doc.addAttributes({ href: "" });
          }
        }
      } catch (error) {
        setError(true);
        setMsg(error);
      }
    });
  });

  const docListItems = document.querySelectorAll(".doc-list-item");
  docListItems.forEach((docListItem) => {
    docListItem.addEventListener("click", async (e) => {
      e.stopImmediatePropagation();

      const docHref = docListItem.getAttribute("data-doc-href");

      docComponent.addAttributes({ href: docHref });

      document.querySelector("#upload-doc").classList.add("d-none");
    });
  });
};

export const createDocManager = async (
  editor,
  pathName,
  docComponent,
  setMsg,
  setError,
  presentation
) => {
  const docDiv = document.querySelector("#upload-doc");

  if (docDiv.classList.contains("d-none")) {
    docDiv.classList = "";
    docDiv.innerHTML = "";
  }

  const modal = `<div class="fade modal show" role="dialog" aria-modal="true" style="display: block;">
        <div style="padding-right: 17px; display: block;" class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title h5">Document Manager</div>&nbsp
                    <button class="btn-close" aria-label="close"></button>
                </div>
                <div class="modal-body">
                    <div style="height: 300px" id="doc-upload-container">
                        <div class="row">
                            <div class="col" style="border-right: 1px solid #ccc; height: 280px">
                                <form>
                                    <div class="form-group">
                                        <label for="docFile">Select Document</label>
                                        <input type="file" accept="application/pdf" class="form-control" name="docFile" id="docFile" />
                                    </div>
                                    <div class="form-group mt-2">
                                        <button id="submit-doc" class="btn btn-primary">Add Document</button>
                                    </div>
                                </form>
                            </div>
                            <div class="col" style="height: 280px; overflow: scroll">
                                <div id="doc-list">
                                    <h6>Documents for this design</h6>
                                    <ul class="list-group" id="doc-list-group"></ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="fade modal-backdrop show"></div>`;

  docDiv.innerHTML = modal;

  const closeBtn = document.querySelector("#upload-doc .btn-close");
  closeBtn.addEventListener("click", () => {
    docDiv.className = "d-none";
  });

  const submitButton = document.querySelector("#submit-doc");
  submitButton.addEventListener("click", async (e) => {
    e.preventDefault();
    showLoader();
    try {
      const fileInput = document.querySelector("#docFile");
      if (fileInput.value === "") {
        setError(true);
        setMsg("Please select the document file");
        hideLoader();
        return;
      }

      document.querySelector("#custom-loader").style["z-index"] = 9999;

      const formData = new FormData();
      Object.keys(fileInput.files).forEach((key) => {
        formData.append("asset", fileInput.files.item(key));
      });

      submitButton.setAttribute("disabled", true);
      submitButton.textContent = "Uploading...";

      const response = await postRequest(`assets/${pathName}/docs`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      submitButton.removeAttribute("disabled");
      submitButton.textContent = "Add Document";

      if (response.data.isSuccess) {
        if (response.data.assetData.length > 0) {
          setError(false);
          setMsg("Document uploaded successfully");
        }
      } else {
        setError(true);
        setMsg(response.data.msg);
      }

      document.querySelector("#custom-loader").removeAttribute("style");
      fileInput.value = "";

      updateDocsList(editor, pathName, docComponent, setMsg, setError,presentation);

      // call update doc list
    } catch (err) {
      setError(true);
      setMsg(err);
    }
    submitButton.removeAttribute("disabled");
    submitButton.textContent = "Add Document";
    document.querySelector("#custom-loader").removeAttribute("style");
    hideLoader();
  });

  updateDocsList(editor, pathName, docComponent, setMsg, setError,presentation);
  // call update doc list
};
